import React from "react";
import {InputLabel} from "peggirkit";
import {FormattedMessage} from "react-intl";

export const label = (messageId: string, isRequired: boolean) => (
    <InputLabel hint={<FormattedMessage id={isRequired ? "required" : "optional"}/>}>
        <FormattedMessage id={messageId}/>
    </InputLabel>
);